// Modal Actions
export const openModal = (item, savedItems) => ({
  type: 'OPEN_MODAL',
  item,
  savedItems,
});

export const closeModal = item => ({
  type: 'CLOSE_MODAL',
  item,
});
